import { NgModule } from '@angular/core';

import { MasterFundosActions } from './master-fundos.actions';

@NgModule({
  providers: [
    MasterFundosActions
  ]
})
export class MasterFundosActionsModule {}
